<script>
  import { onDestroy, onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import queryString from 'query-string';
  import { listenToLiveChannels } from '../../../Api/api';
  import PulseStatusAnim from '../../Common/PulseStatusAnim.svelte';
  import Channel from './Channel.svelte';
  import { categories } from '../../../Store/store';
  import { getCategoryDisplayName } from '../../../common/utils';

  let unsubscribeListenToLiveChannels;
  let showSpinner = true;
  let queryParam = {};
  let grouped = null;

  $: $categories.length && listenToPublishedChannels();

  onMount(async () => {
    if (typeof window !== 'undefined') {
      queryParam = queryString.parse(window.location.search);
    }
  });

  onDestroy(() => {
    if (unsubscribeListenToLiveChannels) {
      unsubscribeListenToLiveChannels();
    }
  });

  const listenToPublishedChannels = async () => {
    unsubscribeListenToLiveChannels = await listenToLiveChannels((snapShot) => {
      let c = [];
      grouped = null;
      snapShot.forEach(async (doc) => {
        c.push({ id: doc.id, ...doc.data() });
      });
      if (queryParam && queryParam.type) {
        c = c.filter((channel) =>
          queryParam.type === 'all' ? true : channel.category === queryParam.type,
        );
      }
      grouped = {};
      c.reduce((acc, cur) => {
        if (cur.category) {
          if (!acc[cur.category]) {
            acc[cur.category] = [];
          }
          acc[cur.category].push(cur);
        } else {
          if (!acc['TV 2-chat']) {
            acc['TV 2-chat'] = [];
          }
          acc['TV 2-chat'].push(cur);
        }
        return acc;
      }, grouped);
      showSpinner = false;
    });
  };
</script>

<div class="published-container">
  <div class="app-header">
    <h1>Livechats</h1>
  </div>
  {#if showSpinner}
    <div class="status" in:fade>
      <PulseStatusAnim />
    </div>
  {:else}
    <div class="content">
      {#if !Object.keys(grouped).length}
        <div class="empty-state" in:fade>
          <img src="../../chat_emptystate.png" alt="" />
          <h1>Akkurat nå er det ingen pågående chats</h1>
          <p>
            Her kan du snakke med våre eksperter om temaer som f.eks. fotballkamper, overganger og
            vintersport.
          </p>
        </div>
      {/if}
      <div class="channels" in:fade>
        {#each Object.entries(grouped) as [typeKey, channelsValue]}
          <h2 class="type-heading">
            {getCategoryDisplayName($categories, typeKey)}
          </h2>
          {#each channelsValue as channel}
            <Channel {channel} />
          {/each}
        {/each}
      </div>
    </div>
  {/if}
</div>

<style src="./published.scss">
</style>
